/**
 * Created by neo on 28.09.21.
 */
import { makeAutoObservable } from 'mobx';
import { TrackingParameter } from './TrackingParameter';

export type ProgramTrackingParameter = {
  trackingParameter: TrackingParameter;
  optional: boolean;
};

export function createProgramTrackingParameter(json?: Partial<ProgramTrackingParameter>): ProgramTrackingParameter {
  return makeAutoObservable({
    trackingParameter: json?.trackingParameter ?? 'bodyMass',
    optional: json?.optional ?? false,
  });
}
